import fetchModels from "../../mixin/store/api/fetchModels";
import deleteModel from "@/mixin/store/api/deleteModel";
import fetchModel from "@/mixin/store/api/fetchModel";
import pushModel from "@/mixin/store/api/pushModel";
import changeModel from "@/mixin/store/api/changeModel";
import axios from "@/plugins/axios";

export default {
    actions: {
        fetchServices(context, page) {
            return fetchModels(context, 'services?order[id]=desc', page, 'updateServices');
        },
        fetchAllServices(context) {
            if(context.state.services.isNeedFetch) {
                return fetchModels(context, 'services?order[id]=desc', null, 'updateServices');
            }
        },
        fetchService(context, id) {
            return fetchModel(context, 'services', id, 'updateService');
        },
        pushServices(context, data) {
            context.state.services.isNeedFetch = false
            return pushModel(context, 'services', data)
        },
        changeService(context, data) {
            context.state.services.isNeedFetch = false
            data.currency = '/api/currencies/' + data.currency
            return changeModel(context, 'services/' + data.id, data, 'updateService')
        },
        deleteService(context, id) {
            context.state.services.isNeedFetch = false
            return deleteModel(context, 'services', id);
        },
        searchService(context, search) {
            let url = 'services?page=' + search.page + '&order[id]=desc'

            if (search.name) {
                url += '&name=' + search.name
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateServices', data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
    },
    mutations: {
        updateServices(state, data) {
            state.services = data
            state.services.isNeedFetch = false
        },
        updateServicesIDB(state, data) {
            state.services.models = data
        },
        updateService(state, data) {
            state.service = data
        },
    },
    state: {
        service: {},
        services: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
    },
    getters: {
        getService(state) {
            return state.service
        },
        getServices(state) {
            return state.services.models
        },
        getServicesTotalCount(state) {
            return state.services.totalItems
        },
    },
}
